import React from 'react';
import styled from 'styled-components';

const Tag = ({ color, children, className }) => (
  <StyledTag color={color} className={className}>
    {children}
  </StyledTag>
);

const StyledTag = styled.span`
  padding: 10px 15px;
  border-radius: 4px;
  background-color: ${({ color }) => colors[color].background};
  color: ${({ color }) => colors[color].label};
  width: fit-content;
  font-weight: var(--font-weight-base);
`;

const colors = {
  purple: {
    background: 'var(--purple-10)',
    label: 'var(--purple-70)'
  },
  sky: {
    background: 'var(--sky-10)',
    label: 'var(--sky)'
  },
  orange: {
    background: 'var(--orange-10)',
    label: 'var(--orange-70)'
  },
  grape: {
    background: 'var(--grape-10)',
    label: 'var(--grape-70)'
  },
  green: {
    background: 'var(--green-10)',
    label: 'var(--green-70)'
  },
  blueberry: {
    background: 'var(--blueberry-10)',
    label: 'var(--blueberry-70)'
  },
  grey: {
    background: 'var(--gray-light)',
    label: 'var(--gray-dark)'
  }
};

export default Tag;
